import type { CheckoutShippingPackage } from "@/types/cart";
import type { ShippingSelection } from "@/types/shipping";
import { ShippingOptionCard } from "./ShippingOptionCard";
import { useShippingBadges } from "@/hooks/useShippingBadges";

interface ShippingOptionsProps {
  disabled: boolean;
  onSelect: (packageId: number | string, rateId: string) => void;
  packages: CheckoutShippingPackage[];
  selection?: ShippingSelection;
  selectable?: boolean;
  /** Linhas enxutas, sem cartões (página do carrinho). */
  compact?: boolean;
}

export function ShippingOptions({
  disabled,
  onSelect,
  packages,
  selection,
  selectable = true,
  compact = false,
}: ShippingOptionsProps) {
  const badgeFor = useShippingBadges(packages);
  if (compact) {
    return (
      <div className="space-y-2">
        {packages.map((shippingPackage, packageIndex) => (
          <fieldset key={String(shippingPackage.packageId)} disabled={disabled} className="min-w-0">
            <legend className={packages.length > 1 ? "mb-1 text-xs font-semibold text-foreground" : "sr-only"}>
              {packages.length > 1 ? shippingPackage.name || `Entrega ${packageIndex + 1}` : "Opções de entrega"}
            </legend>
            <div className="divide-y divide-dashed divide-slate-200">
              {shippingPackage.rates.map((rate) => (
                <ShippingOptionCard
                  key={rate.rateId}
                  compact
                  rate={rate}
                  destination={shippingPackage.destination}
                  badge={badgeFor(shippingPackage.packageId, rate.rateId)}
                  groupName={`shipping-${shippingPackage.packageId}`}
                  checked={selection?.packageId === shippingPackage.packageId && selection.rateId === rate.rateId}
                  disabled={disabled}
                  selectable={selectable}
                  onSelect={() => onSelect(shippingPackage.packageId, rate.rateId)}
                />
              ))}
            </div>
          </fieldset>
        ))}
      </div>
    );
  }
  return (
    <div className="space-y-5">
      {packages.map((shippingPackage, packageIndex) => (
        <fieldset
          key={String(shippingPackage.packageId)}
          disabled={disabled}
          className="min-w-0"
        >
          <legend className="mb-3 text-sm font-semibold text-foreground">
            {packages.length > 1
              ? shippingPackage.name || `Entrega ${packageIndex + 1}`
              : "Opções disponíveis"}
          </legend>
          <div className="space-y-3">
            {shippingPackage.rates.map((rate) => (
              <ShippingOptionCard
                key={rate.rateId}
                rate={rate}
                destination={shippingPackage.destination}
                badge={badgeFor(shippingPackage.packageId, rate.rateId)}
                groupName={`shipping-${shippingPackage.packageId}`}
                checked={
                  selection?.packageId === shippingPackage.packageId &&
                  selection.rateId === rate.rateId
                }
                disabled={disabled}
                selectable={selectable}
                onSelect={() =>
                  onSelect(shippingPackage.packageId, rate.rateId)
                }
              />
            ))}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
